import Item from "./Item";

export default function ProductList({ activePack, pack }: { activePack: string, pack: any }) {

    return (
        <ul role="list" className={`grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-8 w-full pt-6 ${activePack === pack.name ? '' : 'absolute left-[9999px]'}`}>
            {pack.products && pack.products.map((item: any) => (
                <Item key={`card_${item.id}`} item={item} />
            ))}
        </ul>
    )
};
